import { Button, ButtonProps } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sleep } from '../../utils/helpers';

interface Props {
    onClick: () => void;
    disabled: boolean;
}

const ResetFormButton = ({ onClick, disabled }: Props) => {
    const { t } = useTranslation('forms');
    const [isResetingForm, setIsResetingForm] = useState(false);

    const handleOnClick: ButtonProps['onClick'] = () => {
        setIsResetingForm(true);
        onClick();
        sleep(500).then(() => setIsResetingForm(false));
    };

    return (
        <Button type="primary" onClick={handleOnClick} loading={isResetingForm} disabled={disabled}>
            {t('undoChanges')}
        </Button>
    );
};
export default ResetFormButton;
